import {useQuery} from "@tanstack/react-query";
import {getCategoriesByIdNew} from "../../../../data/api/Customer";
import {BaseResponse} from "../../../../data/model/BaseResponse";
import {CategoryModelNew} from "../../../../data/model/Category";
import {HStack, Image, Text, VStack} from "@chakra-ui/react";
import * as React from "react";
import {EventDetailLoading} from "../Events/EventDetails/EventDetails";

export const CategoryDetailPage = ({id}: { id: string | undefined }) => {
    // const {id} = useParams();
    const response = useQuery({queryKey: ["get-category", id], queryFn: () => getCategoriesByIdNew(id)})
    const {data, isLoading} = response || {};
    const eventResponse = data?.data as BaseResponse<CategoryModelNew> || {};

    return <VStack h={"100%"} w={"100%"} justifyContent={"center"} alignItems={"center"}>
        {isLoading ? <EventDetailLoading/> : <CategoryDetailSection model={eventResponse.data}/>}
    </VStack>
}

const CategoryDetailSection = ({model}: { model?: CategoryModelNew }) => {
    const {image, name, description} = model || {};

    return <HStack px={"10%"} py={"24px"} spacing={"48px"}>
        <Image maxW={"30%"} backgroundColor={"white"} borderRadius={"16px"} mt={"16px"} objectFit={"fill"}
               boxShadow={"1px 1px 10px rgba(0,0,0,0.1)"} src={image?.url} w={"100%"}/>
        <VStack w={"100%"} spacing={"8px"}>
            <Text fontSize={"32px"} color={"primary.400"} fontWeight={"bold"}>{name}</Text>
            <Text fontSize={"16px"} mt={"24px"}>
                {description}
            </Text>
        </VStack>
    </HStack>
}
